import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

interface DepositInfo {
  deposit_address: string;
  chain: string;
  chain_id: number;
  usdc_contract: string;
  memo_required: boolean;
  instructions: string;
}

export const Billing = () => {
  const info = useQuery({
    queryKey: ['deposit-info'],
    queryFn: () => api.get<DepositInfo>('/me/payments/deposit-info'),
  });

  return (
    <main className="page">
      <header className="hero">
        <div>
          <p className="eyebrow">Billing & deposits</p>
          <h1>Fund the account with USDC when you are ready.</h1>
          <p className="lead">
            Trial starts in paper mode. Paid tiers are credited automatically by the payment indexer
            after an Arbitrum USDC transfer is detected.
          </p>
        </div>
        <div className="card">
          <span className="label">Settlement</span>
          <p className="stat-value">{info.data?.chain ?? 'Arbitrum'}</p>
          <p className="muted">USDC subscription payments</p>
        </div>
      </header>
      {info.isLoading && <p>Loading…</p>}
      {info.data && (
        <section className="panel stack" style={{ marginTop: '1rem' }}>
          <div className="section-header">
            <h2>Your deposit address</h2>
            <span className="badge badge-success">Memo not required</span>
          </div>
          <p
            style={{
              background: 'rgba(2, 6, 23, 0.48)',
              borderRadius: 16,
              padding: '1rem',
              wordBreak: 'break-all',
            }}
          >
            <code>{info.data.deposit_address}</code>
          </p>
          <div className="grid grid-2">
            <div className="card">
              <span className="label">Chain</span>
              <p className="stat-value">{info.data.chain}</p>
              <p className="muted">Chain ID {info.data.chain_id}</p>
            </div>
            <div className="card">
              <span className="label">USDC contract</span>
              <p style={{ wordBreak: 'break-all' }}>
                <code>{info.data.usdc_contract}</code>
              </p>
            </div>
          </div>
          <p className="muted">{info.data.instructions}</p>
        </section>
      )}
    </main>
  );
};
